module.exports = "<invoice-page></invoice-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/invoice.html
// module id = 1724
// module chunks = 0